export enum ListReferralStatus {
    Active = 'Active',
    Accepted = 'Accepted',
    Void = 'Void'
}
